export default __webpack_public_path__ + "static/media/vector3.e2c9be77.gif";